import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListNewsBrand from "../Components/News Brand/listNewsBrand";
import AddNewsBrand from "../Components/News Brand/addNewsBrand";
import EditBrandNews from "../Components/News Brand/editNewsBrand";
import ViewBrandNews from "../Components/News Brand/viewNewsBrand";
const NewsBrandRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route path="/fa_brands" element={<ListNewsBrand></ListNewsBrand>}></Route>
      <Route
        path="/fa_brands/add"
        element={canAdd ? <AddNewsBrand /> : <Navigate to="/fa_brands" replace />}
      ></Route>
      <Route
        path="/fa_brands/edit/:id"
        element={ canEdit ? <EditBrandNews /> : <Navigate to="/fa_brands" replace />}
      ></Route>
      <Route
        path="/fa_brands/view/:id"
        element={<ViewBrandNews></ViewBrandNews>}
      ></Route>
    </Routes>
  );
};

export default NewsBrandRoutes;
